import { render, staticRenderFns } from "./OperaSettingSocreWindow.vue?vue&type=template&id=fdc1c978&scoped=true&"
import script from "./OperaSettingSocreWindow.vue?vue&type=script&lang=js&"
export * from "./OperaSettingSocreWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaSettingSocreWindow.vue?vue&type=style&index=0&id=fdc1c978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc1c978",
  null
  
)

export default component.exports